import React from 'react';
import { Label } from 'semantic-ui-react';

export default ({ touched, error, submitError, dirtySinceLastSubmit }) => {
  if (touched && (error || (submitError && !dirtySinceLastSubmit))) {
    return <Label basic color="red" pointing>{error || submitError}</Label>;
  }
  return null;
};
